import { ReactNode } from 'react'
import Styles from './RequestCard.module.scss'
import cx from 'classnames'

interface Props {
  children: ReactNode
  role?: 'requester' | 'reviewer'
}

export const RequestCard = ({ children, role = 'reviewer' }: Props) => (
  <div className={cx(Styles.requestCard, Styles[role])}>
    {children}
  </div>
)
